import React from 'react'
import App from './/pages/App'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import configSettings from 'settings/config.json'
import { I18nProvider } from '@lingui/react'
import { i18n } from '@lingui/core'
import { messages as messagesEnUs } from './locales/en-US/messages'
import { messages as messagesEsMx } from './locales/es-MX/messages'
import { LocalStorageKey } from 'helpers/constants'
import moment from 'moment/min/moment-with-locales'
import './assets/scripts/font-loader.js'

i18n.load('en-US', messagesEnUs)
i18n.load('es-MX', messagesEsMx)

const languages = ['en-US', 'es-MX']

let language = localStorage.getItem(LocalStorageKey.language)

if (!language || languages.indexOf(language) === -1) {
  language = 'en-US'
  localStorage.setItem(LocalStorageKey.language, language)
}

localStorage.setItem(LocalStorageKey.language, language)
i18n.activate(language)
moment.locale(language.substring(0, 2))

const root = createRoot(document.getElementById('root'))

root.render(
  <I18nProvider i18n={i18n}>
    <GoogleOAuthProvider clientId={configSettings.GoogleOAuthClientID}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GoogleOAuthProvider>
  </I18nProvider>
)
